class MobilePhoneValidationSuccessController {
    $onInit() {
        this.formattedNumber = this.formatNumber(this.phoneNumber);
    }

    formatNumber(mobileNumber) {
        if (mobileNumber.length === 11) {
            // remove MSISDN fix
            mobileNumber = mobileNumber.substring(2, mobileNumber.length);
        }

        if (mobileNumber.length === 10) {
            // remove leading zero
            mobileNumber = mobileNumber.substring(1, mobileNumber.length);
        }

        // Add the Australian prefix (only AUS numbers allowed) and spaces between sets of digits.
        return `+61 ${mobileNumber.substring(0, 3)} ${mobileNumber.substring(3, 6)} ${mobileNumber.substring(6, 9)}`;
    }
}

const MobilePhoneValidationSuccessComponentDefinition = {
    controller: MobilePhoneValidationSuccessController,
    template: require('./mobile-phone-validation-success.component.html').trim(),
    bindings: {
        successMessage: '<',
        phoneNumber: '<',
        onEnterNewMobilePhoneNumber: '&',
    },
};

module.exports = {
    MobilePhoneValidationSuccessController,
    MobilePhoneValidationSuccessComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/common/mobilephonevalidator/mobile-phone-validation-success.component.js